import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import PostComment from '../discussionBoard/postComment';
import Comment from '../discussionBoard/comment';
import FileDownload from '../../shared/commonComponents/FileDownload';
import { useHistory } from "react-router";
import { UserActivityAxios, NetworkAxios, OnboardingAxios } from "../../API";
const ViewSolution = () => {
    const anchorRef = useRef(null);
    const userDetails = useSelector((state) => state.auth.loggedInUser);
    const offeringUserId = useSelector((state) => state.auth.loggedInUser.offeringUserId);
    const [comments, setcomments] = useState([]);
    const [localCommentList, setLocalCommentList] = useState(comments);
    const [isFiltered, setIsFiltered] = useState(false);
    // const [selectedUser, setSelectedUser] = useState(null);
    const [solution, setSolution] = useState([]);
    const [files, setFiles] = useState([]);
    const [mailContent, setMailContent] = useState("");
    const history = useHistory();
    let param = useParams();
    const solutionId = param.solutionId;
    const teamId = param.teamId;
    let messagePoint = { ...useSelector((state) => state.auth.messagePoint) };

    const getSolutionbyId = () => {
        //TODO: change forum id from solutionID
        UserActivityAxios.get('Solution/getsolutionbyid/' + solutionId + "/" + offeringUserId)
            .then(function (response) {
                var temp = response.data;
                setSolution([]);
                setSolution(temp);
                let tempfile = temp.solutionFiles.filter(x => x.fileType === 1);
                setFiles(tempfile);

            })
            .catch(function (error) {
                console.log(error);
            });
    };


    const getSolutionComments = () => {
        NetworkAxios.get('SolutionComment/getsolutioncommentsbysolutionid/' + solutionId + "/" + offeringUserId)
            .then(function (response) {
                var temp = response.data;
                setcomments([]);
                setLocalCommentList([]);
                setcomments(temp);
                setLocalCommentList(temp);
            })
            .catch(function (error) {
                console.log(error);
            });
    };
    useEffect(() => {
        getSolutionbyId();
        getSolutionComments();
        getTeamUsers();
    }, []);


    const [teamUsers, setTeamUsers] = useState([]);
    const getTeamUsers = () => {
        OnboardingAxios.get(`OfferingUsers/getusersbyteam/${teamId}`)
            .then(function (response) {
                setTeamUsers(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const onshareclick = () => {
        let requestData = {
            requestModel: {
                solutionId: solution.id,
                sharedBy: offeringUserId
            },
            message: messagePoint,
            isBackgroundJob: false
        };

        NetworkAxios.post('SolutionShare/sharesolution', requestData)
            .then(function (reponse) {
                var notificationData = [];
                teamUsers.forEach(element => {
                    notificationData.push({
                        offeringId: userDetails.offeringId,
                        missionId: userDetails.missionId,
                        activityBy: userDetails.offeringUserId,
                        offeringUserId: element.id,
                        teamId: element.teamId,
                        notificationText: ` shared your solution.`,
                        actionRoute: JSON.stringify({ action: null, actionText: "NA" })
                    });
                });
                var requestObject = {
                    requestModel: notificationData,
                    message: messagePoint,
                    isBackgroundJob: false
                };
                UserActivityAxios.post('Notification/sendnotifications', requestObject)
                    .then(function (res) {
                    })
                    .catch(function (er) {
                        console.log(er);
                    });
            })
            .catch(function (error) {
                console.log(error);
            });
        //to do find alternative to window.location.href sanitize for URl
        var url = window.location.protocol + window.location.hostname + "/viewsolution/" + solutionId + "/" + teamId;
        url = new URL(url);
        var mail = "mailto:?subject=" + solution.solutionName + " (" + solution.teamName + ")" +
            "&body=" + url +
            "%0D%0D" +
            solution.shortDescription;

        var link = document.createElement("a");
        link.href = mail;
        link.target = "_blank";
        link.click();
    };
    // useEffect(() => {
    //     if (mailContent !== "") {
    //         anchorRef.current?.click();
    //     }
    // }, [mailContent]);

    const SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file|sms):|[^&:/?#]*(?:[/?#]|$))/gi;

    /** A pattern that matches safe data URLs. It only matches image, video, and audio types. */
    const DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+\/]+=*$/i;

    const _sanitizeUrl = (url) => {
        if (url === "null" || url.length === 0 || url === "about:blank") return "about:blank";
        if (url.match(SAFE_URL_PATTERN) || url.match(DATA_URL_PATTERN)) return url;
        return `unsafe:${url}`;
    };

    const onChangeLikeClick = () => {
        if (solution.isLiked) {


            UserActivityAxios.put('Solution/unlikeSolution/' + solution.id + "/" + offeringUserId)
                .then(function (reponse) {
                    getSolutionbyId();
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
        else {
            var data = {

                solutionId: solution.id,
                offeringUserId: offeringUserId
            };
            UserActivityAxios.post('Solution/likesolution', data)
                .then(function (reponse) {
                    var notificationData = [];
                    teamUsers.forEach(element => {
                        notificationData.push({
                            offeringId: userDetails.offeringId,
                            missionId: userDetails.missionId,
                            activityBy: userDetails.offeringUserId,
                            offeringUserId: element.id,
                            teamId: element.teamId,
                            notificationText: ` liked your solution.`,
                            actionRoute: JSON.stringify({ action: "Like Solution", solutionId: solution.id, teamId: solution.teamId, actionText: "View" })
                        });
                    });
                    var requestObject = {
                        requestModel: notificationData,
                        message: messagePoint,
                        isBackgroundJob: false
                    };
                    UserActivityAxios.post('Notification/sendnotifications', requestObject)
                        .then(function (res) {
                        })
                        .catch(function (er) {
                            console.log(er);
                        });
                    getSolutionbyId();
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    };

    const setLikeItem = (islike, item) => {
        var temp = [...comments];
        if (item.parentCommentId == null || item.parentCommentId == undefined || item.parentCommentId == 0) {
            var index = temp.map(function (e) { return e.id; }).indexOf(item.id);
            temp[index]["isLiked"] = islike;
            if (islike) {
                temp[index]["likes"] = temp[index]["likes"] + 1;
            }
            else {
                temp[index]["likes"] = temp[index]["likes"] - 1;
            }
        }
        else {
            var parentIndex = temp.map(function (e) { return e.id; }).indexOf(item.parentCommentId);
            var index = temp[parentIndex]["replies"].map(function (e) { return e.id; }).indexOf(item.id);
            temp[parentIndex]["replies"][index]["isLiked"] = islike;
            if (islike) {
                temp[parentIndex]["replies"]["likes"] = temp[parentIndex]["replies"]["likes"] + 1;
            }
            else {
                temp[parentIndex]["replies"]["likes"] = temp[parentIndex]["replies"]["likes"] - 1;
            }
        }
        setcomments([...temp]);
        setLocalCommentList([...temp]);
    };

    const backToGallery = () => {

        history.push("/gallery");
    };

    const sendNotification = () => {
        var notificationData = [];
        teamUsers.forEach(element => {
            notificationData.push({
                offeringId: userDetails.offeringId,
                missionId: userDetails.missionId,
                activityBy: userDetails.offeringUserId,
                offeringUserId: element.id,
                teamId: element.teamId,
                notificationText: ` commented on your solution.`,
                actionRoute: JSON.stringify({ action: "Comment Solution", solutionId: solution.id, teamId: solution.teamId, actionText: "View" })
            });
        });
        var requestObject = {
            requestModel: notificationData,
            message: messagePoint,
            isBackgroundJob: false
        };
        UserActivityAxios.post('Notification/sendnotifications', requestObject)
            .then(function (res) {
            })
            .catch(function (er) {
                console.log(er);
            });
    };

    return (<>

        <div className="backToGalleryDiv">
            <div>
                <span className="backIcon"></span>
                <span className="backToGalleryText" onClick={() => backToGallery()}>Back to Gallery</span>
            </div>
            <div className="likeShareCommentIconDiv push">
                <div className="pointer">
                    <span onClick={() => { onChangeLikeClick(); }} className={`vlikeIcon ${solution.isLiked ? "vcommentliked" : "vcommentnotliked"}`}></span><span className="countText" style={{ top: "-1px" }}>{solution.likeCount}</span>
                </div>
                <div className="pointer">
                    <span className="commentIcon"></span><span className="countText">{solution.commentCount}</span>
                </div>
                <div className="pointer">
                    <span className="viewIcon"><i className="fa fa-eye" aria-hidden="true"></i></span><span className="countText">{solution.viewCount}</span>
                </div>
                <div className="pointer">
                    <span className="shareIcon" onClick={() => { onshareclick(); }}></span><span className="countText">{solution.shareCount}</span>
                </div>
            </div>
        </div>
        <div className="vSolution-main-container">
            <div className="d-flex">

                <div className="solutionContainer">
                    <div className="vSolutionName mt-15">{solution.solutionName}</div>
                    <div className="vTeamName mt-15">{solution.teamName}</div>
                    <div className="vBrief mt-15">Brief:</div>
                    <div className="vBriefDesc">{solution.shortDescription}</div>
                    <div className="vFile">Files</div>
                    <Row className="fileRow">
                        {files.map((item, index) => {
                            return <FileDownload key={index} {...item} className="col-6 mb-15" />;
                        })}
                    </Row>
                    <div className="vDetails ">Details</div>
                    <div className="vDetailDesc" dangerouslySetInnerHTML={{ __html: solution.longDescription }} ></div>
                    {/* <div className="vDetails ">Selected Award Categories</div>
                    <div className="vTags" >
                        {solution.solutionTags?.length > 0 && solution.solutionTags.map(tag => {
                            return <div className="tags-div" key={tag.id}>{tag.tagName}</div>;
                        })}
                    </div> */}
                </div>
                <div className="planetImage"></div>
            </div>

            <Row>
                <Col className="commentsLabel">
                    <div className="px-3 py-4 content">
                        <div className="comment-seprator">
                            <div className="background"></div>
                            {<span className="title"><nobr>Comments</nobr></span>}
                        </div>
                    </div>
                </Col>
            </Row>
            {
                <div className="scroll-content ">

                    {!isFiltered &&
                        <PostComment sendNotification={sendNotification} showAssignment={false} reloadComments={getSolutionComments} commentFrom="viewSolution" solutionId={solutionId} />
                    }
                    {
                        localCommentList && localCommentList.sort((a, b) => a.commentedOn < b.commentedOn ? 1 : -1).map((item, index) => {
                            return <Comment key={index} setLikeItem={setLikeItem} solutionId={solutionId} commentFrom="viewSolution" reloadComments={getSolutionComments} comment={item} />;
                        })
                    }
                </div>}
        </div>
        {/* <a ref={anchorRef} className='email_anchor' href={mailContent}></a> */}
    </>);
};

export default ViewSolution;